// extracted by mini-css-extract-plugin
module.exports = {"deviceBox":"device_deviceBox__1DrNT","deviceLink":"device_deviceLink__2BeYT","deviceImg":"device_deviceImg__1wDq0","title":"device_title__2w1sb"};